import React from "react";
import { useNavigate } from "react-router-dom";
import { Mail, Sparkles, X, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const VisitorRfqDialog = ({ vendor, onClose }) => {
  const navigate = useNavigate();

  const copy = () => {
    const email = vendor.contact_email;
    if (!email) return toast.error("This vendor has not published an email yet");
    navigator.clipboard?.writeText(email);
    toast.success(`Email copied — ${email}`);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-5 bg-slate-950/60 backdrop-blur-sm" onClick={onClose}>
      <div
        data-testid="visitor-rfq-dialog"
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md bg-card border border-border rounded-2xl shadow-2xl"
      >
        <div className="flex items-start justify-between gap-3 px-6 py-4 border-b border-border">
          <div>
            <div className="font-semibold text-slate-900 dark:text-slate-100">Send an RFQ</div>
            <div className="text-xs text-muted-foreground mt-0.5">to {vendor.company_name}</div>
          </div>
          <button data-testid="close-visitor-dialog" onClick={onClose} className="text-muted-foreground hover:text-foreground">
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="p-6 space-y-3">
          <button
            data-testid="visitor-signup-option"
            onClick={() => { onClose(); navigate("/login?type=buyer&mode=register"); }}
            className="w-full text-left rounded-xl border border-primary bg-primary/5 hover:bg-primary/10 transition-colors px-4 py-4"
          >
            <div className="flex items-center gap-2 font-semibold text-slate-900 dark:text-slate-100">
              <Sparkles className="w-4 h-4 text-primary" /> Send it through Matiqs — free
            </div>
            <p className="text-xs text-muted-foreground mt-1.5">
              Create a free contractor account, upload your BOQ once and invite as many vendors as you like.
              Every reply lands in one comparison sheet.
            </p>
          </button>

          <button
            data-testid="visitor-copy-email-option"
            onClick={copy}
            className="w-full text-left rounded-xl border border-border hover:border-primary/40 transition-colors px-4 py-4"
          >
            <div className="flex items-center gap-2 font-semibold text-slate-900 dark:text-slate-100">
              <Copy className="w-4 h-4 text-muted-foreground" /> Copy their email instead
            </div>
            <p className="text-xs text-muted-foreground mt-1.5">
              {vendor.contact_email
                ? <>Email <span className="font-mono">{vendor.contact_email}</span> directly from your own inbox.</>
                : "This vendor has not published an email yet."}
            </p>
          </button>

          <Button variant="ghost" data-testid="visitor-signin-link" onClick={() => { onClose(); navigate("/login?type=buyer"); }}
                  className="w-full h-10 font-semibold gap-2 text-muted-foreground">
            <Mail className="w-4 h-4" /> Already have an account? Sign in
          </Button>
        </div>
      </div>
    </div>
  );
};
